<template>
  <Layout
    v-if="
      !['vici login', 'login', 'CDR Details Info', 'CC Dashboard'].includes(
        $route.name
      ) && !isNonMounted
    "
  >
    <a-layout-content
      :class="[
        theme == 'light' ? '' : 'bg-secondary',
        $route.name == 'Porting Chat' ? 'pb-0' : '',
        $route.name == 'login' ? 'page-content-section1 bg-white' : '',
        $route.name == 'CC Dashboard'
          ? 'page-content-logger bg-body-secondary'
          : '',
      ]"
      class="page-content-section"
    >
      <!-- :style="{ padding: '24px 16px', minHeight: '850px' }" -->
      <router-view />
    </a-layout-content>
  </Layout>
  <a-layout-content
    :class="[
      theme == 'light' ? '' : 'bg-secondary',
      $route.name == 'Porting Chat' ? 'pb-0' : '',
      $route.name == 'login' ? 'page-content-section1 bg-white' : '',
      $route.name == 'CC Dashboard'
        ? 'page-content-logger bg-body-secondary'
        : '',
    ]"
    class="page-content-section"
    v-else
  >
    <!-- :style="{ padding: '24px 16px', minHeight: '850px' }" -->
    <router-view />
  </a-layout-content>
  <a-modal
    v-model:visible="isConfirmationVisible"
    :footer="null"
    :header="null"
    centered
    width="450px"
  >
    <div class="px-4">
      <div class="text-center">
        <vue-feather
          type="alert-circle"
          class="text-warning mb-2 me-0"
          size="2rem"
        />
        <h4 class="fw-bold mb-3">
          We will sign you out in
          <b>{{ minutes }}:{{ seconds < 10 ? "0" : "" }}{{ seconds }}</b>
        </h4>
        <p>
          We sign you out of your Intuit products when you're inactive for
          <span class="text-primary"> 30 min </span>
        </p>
        <hr />
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <a-button
          @click="clearResetTimeout()"
          class="bg-success border-0 text-light me-3"
        >
          I need more time
        </a-button>
        <a-button @click="logOut"> Sign Out </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { layoutComputed, authComputed, layoutMethods } from "@/store/helpers";
import AuthService from "@/helpers/authServices/auth.service.js";
import { callAllFuncs } from "@/helpers/BatchService.js";
import Layout from "./components/layout/layout.vue";
import errorHandler from "./helpers/errorHandler";
// import { message } from "ant-design-vue";

export default {
  name: "App",
  data() {
    return {
      inactivityTimeout: 30 * 60 * 1000, // 30 minutes 30 * 60 * 1000
      timeoutId: null,
      isConfirmationVisible: false,
      totalSeconds: 300, // 5 minutes in seconds 300
      minutes: 10,
      seconds: 0,
      timer: null,
      isNonMounted: true,
      accessTokenInterval: null,
    };
  },
  components: { Layout },
  watch: {
    $route() {
      // this.clearResetTimeout();
      if (this?.user) {
        if (!sessionStorage.isLoadPage) {
          this.isNonMounted = false;
          window.location.reload();
          sessionStorage.setItem("isLoadPage", true);
        }
      } else if (
        ["", null, undefined].includes(this.user) ||
        ["", null, undefined].includes(sessionStorage.user)
      ) {
        sessionStorage.clear();
        localStorage.clear();
      }
    },
    theme() {
      if (this.theme == "dark") {
        document.body.classList.add("dark-mode-body");
      } else {
        document.body.classList.remove("dark-mode-body");
      }
    },
  },
  computed: { ...layoutComputed, ...authComputed },
  mounted() {
    // let userData = sessionStorage.user
    //   ? JSON.parse(sessionStorage.getItem("user"))
    //   : null;
    // if (userData) {
    //   this.getNewAccessToken(userData.user.user_uuid);
    // }
    if (this.theme == "dark") {
      document.body.classList.add("dark-mode-body");
    } else {
      document.body.classList.remove("dark-mode-body");
    }
    // if ([null, undefined, ""].includes(sessionStorage.user)) {
    //   localStorage.clear();
    //   sessionStorage.clear();
    // }
    // this.resetTimeout();
    // this.accessTokenInterval = setInterval(() => {
    //   if (userData) {
    //     this.getNewAccessToken(userData.user.user_uuid);
    //   }
    // }, 30 * 60 * 1000); // 30 minute timer
    let newTime = new Date().getTime();
    if (localStorage.LoginTime) {
      let oldTime = localStorage.getItem("LoginTime");
      if (newTime - oldTime > 43200000) {
        localStorage.clear();
        sessionStorage.clear();
        this.$router.go();
      }
    }
    if (this?.user && sessionStorage.isLoadPage) {
      this.isNonMounted = false;
      setTimeout(() => {
        callAllFuncs();
      }, 1500);
    }
    // Throttle the resetTimeout function to be called at most once every 10 seconds
    // const throttledResetTimeout = this.throttle(this.resetTimeout, 10000);
    // document.addEventListener("mousemove", throttledResetTimeout);
    // this.adjustZoom();
    // Event listener to handle window resize
    // window.addEventListener("resize", this.adjustZoom);
  },
  // beforeUnmount() {
  // document.removeEventListener("mousemove", this.resetTimeout);
  // // window.removeEventListener("resize", this.adjustZoom);
  // if (this.accessTokenInterval) {
  //   clearInterval(this.accessTokenInterval);
  // }
  // },
  methods: {
    ...layoutMethods,
    resetTimeout() {
      this.inactivityTimeout = 30 * 60 * 1000;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        if (this.user && sessionStorage.user) {
          this.isConfirmationVisible = true;
        }
        this.startTimer();
      }, this.inactivityTimeout);
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.totalSeconds > 0) {
          this.calculateTime();
          this.totalSeconds--;
        } else {
          this.stopTimer();
          this.logOut();
        }
      }, 1000);
    },
    calculateTime() {
      this.minutes = Math.floor(this.totalSeconds / 60);
      this.seconds = this.totalSeconds % 60;
    },
    stopTimer() {
      clearInterval(this.timer);
    },
    logOut() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push("/login");
      this.isConfirmationVisible = false;
      this.$router.go();
    },
    clearResetTimeout() {
      this.isConfirmationVisible = false;
      this.totalSeconds = 300;
      this.stopTimer();
      this.resetTimeout();
      // if (this.user) {
      //   this.getNewAccessToken(this.user.user.user_uuid);
      // }
    },
    async getNewAccessToken(user_uuid) {
      await AuthService.newAccessToken(user_uuid)
        .then(() => {})
        .catch((error) => {
          errorHandler(error);
          this.logOut();
        });
    },
    throttle(func, limit) {
      let lastFunc;
      let lastRan;
      return function () {
        const context = this;
        const args = arguments;
        if (!lastRan) {
          func.apply(context, args);
          lastRan = Date.now();
        } else {
          clearTimeout(lastFunc);
          lastFunc = setTimeout(function () {
            if (Date.now() - lastRan >= limit) {
              func.apply(context, args);
              lastRan = Date.now();
            }
          }, limit - (Date.now() - lastRan));
        }
      };
    },
    adjustZoom() {
      // Detect device pixel ratio
      const pixelRatio = window.devicePixelRatio;

      if (pixelRatio === 1.25) {
        // Apply the zoom adjustment
        document.body.style.zoom = "80%";
        // message.info("For best view please zoom out display at 80% !!");
      } else {
        // Reset the zoom if needed
        document.body.style.zoom = "100%";
      }
      console.log("Window adjusted !!");
    },
  },
};
</script>
